import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Icon } from './icon';
export const TransactionalTextField = ({
  initValue,
  placeholder,
  onChange,
  allowEmptyValue,
  'data-testid': dataTestId,
  showSearchIcon,
  showClearIcon,
  disabled
}: {
  initValue: string;
  placeholder?: string;
  allowEmptyValue?: boolean;
  onChange: (value: string) => void;
  'data-testid'?: string;
  showSearchIcon?: boolean;
  showClearIcon?: boolean;
  disabled?: boolean;
}) => {
  const [value, setValue] = useState(initValue);
  useEffect(() => {
    if (initValue !== value) {
      setValue(initValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initValue]);
  const commitValue = () => {
    if (!allowEmptyValue && !value) {
      setValue(initValue);
    } else {
      onChange(value);
    }
  };
  return <TextField sx={{
    '.MuiInputBase-root': {
      ...(showSearchIcon ? {
        paddingLeft: '4px'
      } : {}),
      ...(showClearIcon ? {
        paddingRight: '4px'
      } : {})
    },
    '.MuiInputBase-input': {
      ...(showSearchIcon ? {
        paddingLeft: '0px'
      } : {})
    },
    '.MuiInputAdornment-root': {
      ...(showSearchIcon ? {
        margin: '0px'
      } : {})
    }
  }} placeholder={placeholder} tabIndex={1} size='small' value={value} disabled={disabled} onKeyUp={event => {
    if (event.key === 'Enter') {
      commitValue();
    }
  }} onChange={event => setValue(event.target.value)} onBlur={commitValue} slotProps={{
    htmlInput: {
      'data-testid': dataTestId
    },
    input: {
      startAdornment: showSearchIcon && <InputAdornment position='start'>
              <Icon iconClass='material-symbols-search' />
            </InputAdornment>,
      endAdornment: showClearIcon && value && <InputAdornment position='end'>
              <IconButton size='small' aria-label='Clear value' onMouseDown={event => event.preventDefault()} onClick={() => {
          setValue('');
          onChange('');
        }} sx={{
          color: 'var(--mui-palette-text-primary)'
        }}>
                <i className='material-symbols-close-rounded' />
              </IconButton>
            </InputAdornment>
    }
  }} />;
};